import { render, staticRenderFns } from "./MetricDataTable.vue?vue&type=template&id=c8184840&scoped=true&"
import script from "./MetricDataTable.vue?vue&type=script&lang=js&"
export * from "./MetricDataTable.vue?vue&type=script&lang=js&"
import style0 from "../../node_modules/handsontable/dist/handsontable.full.css?vue&type=style&index=0&lang=css&"
import style1 from "./MetricDataTable.vue?vue&type=style&index=1&lang=css&"
import style2 from "./MetricDataTable.vue?vue&type=style&index=2&id=c8184840&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8184840",
  null
  
)

component.options.__file = "MetricDataTable.vue"
export default component.exports